import { createRoot } from 'react-dom/client'
import { Suspense } from 'react'
import axios from 'axios'
import { BrowserRouter as Router } from 'react-router-dom'
import { configureStore } from '@reduxjs/toolkit'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { Sizes, Themes } from '@aura/components/themes'
import { withStyles } from '@aura/components/styles'
import Root from '@aura/components/root'
import Box from '@aura/components/box'
import { ConfigProvider } from './utils/config'
import reducer from './reducers'
import App from './components/app'
import i18n from './constants/i18n'
import styles from './styles'


axios.defaults.withCredentials = true

const store = configureStore({
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [ 'persist/PERSIST' ]
        }
    }),
    reducer
})

const theme = {
    palette: Themes.PUBLIC_LIGHT,
    sizes: Sizes.LARGE,
}

const domNode = document.getElementById('root')
const root = createRoot(domNode)

const RootDiv = withStyles(({ classes, children }) => (
    <Box className={classes.rootDiv}>
        {children}
    </Box>
), styles)

root.render(
    <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <Root theme={{ palette: localStorage.getItem('theme') || Themes.LIGHT }}>
                <ConfigProvider>
                    <Router>
                        <RootDiv>
                            <main id="main-content" role="main">
                                <Suspense fallback={null}>
                                    <App />
                                </Suspense>
                            </main>
                        </RootDiv>
                    </Router>
                </ConfigProvider>
            </Root>
        </Provider>
    </I18nextProvider>
)

const originalConsoleError = console.error

console.error = (message, ...args) => {
    if (typeof message === 'string') {
        return
    }
    originalConsoleError.apply(console, [ message, ...args ])
}